import { all, takeLatest } from 'redux-saga/effects'

import { XmlImportActions } from '../actions'
import { importXml } from './importXml'

export function* importXmlSaga() {
  yield all([takeLatest(XmlImportActions.import, importXml)])
}
